import { NETWORKS, NETWORKS_CODES } from '@/utils/constants/networks'

export default {
    data() {
        return {
            imgHeight: '50%'
        }
    },
    computed: {
        subsections() {
            const network = this.networks[0]

            if (!network) {
                return []
            }

            const sections = this.sortedSectionsByNetwork(network)

            if (this.$store.getters.isRetrPermission) {
                sections.push({
                    title: 'Rozliczenie retr',
                    text: 'Rozliczenie retr',
                    route: {
                        name: 'my-business-retr',
                        params: {
                            alias: network.code.toLowerCase()
                        }
                    },
                    image: {
                        src: require('@/assets/img/my-business/retr.svg'),
                        height: this.imgHeight
                    }
                })
            }

            return sections
        },
        networks() {
            // return MyBusinessNetworks for main user
            if (!this.$store.getters.isShopUser) {
                return this.$store.getters.getMyBusinessNetworks
            }

            // return [] for shopUser without RetrPermission
            if (!this.$store.getters.isRetrPermission) {
                return []
            }

            // return UserNetworks for shopUser with RetrPermission
            let networks = this.$store.getters.getUserNetworks.filter(name => {
                return Object.values(NETWORKS).includes(name)
            }).map(el => {
                const code = el.split('_')[0]
                return {
                    code: NETWORKS_CODES[code]
                }
            })

            // find network by code from this.$route.params?.alias
            const alias = this.$route.params?.alias?.toUpperCase()
            if (alias) {
                networks = networks.filter(el => el.code === alias)
            }

            return networks
        },
        isShopUserNetworkPermission() {
            // check shopUser permission to network from alias
            const networkCodeFromAlias = Object.keys(NETWORKS_CODES).find(key =>
                NETWORKS_CODES[key] === this.$route.params.alias.toUpperCase()
            )

            return this.$store.getters.getUserNetworks.includes(NETWORKS[networkCodeFromAlias])
        }
    },
    methods: {
        async loadNetworksAndCheckPermission() {
            // Load networks
            if (!this.$store.getters.getAvailableUserLocations.length) {
                await this.$store.dispatch('extendedDataFetch', {
                    includes: 'locations'
                })
            }

            // Check isShopUserNetworkPermission
            if (!this.isShopUserNetworkPermission) {
                this.$router.push({ name: 'permission-denied' })
            }
        },
        setTermsImg(code) {
            switch (code) {
            case 'PARTNERS_COUNCIL':
            case 'RETRODISCOUNTS_SERVICES_MANUAL':
            case 'AGREEMENT_TEMPLATE':
            case 'OPERATIONS_MANUAL':
            case 'TERMS_OF_BUSINESS':
            case 'ADVERTISING_MATERIALS':
            case 'CONTRACT_TEMPLATE_OPERATIONAL_MANUAL':
            case 'PURCHASING_GROUP_EQUAL_IN_BUSINESS':
                return {
                    src: require(`@/assets/img/my-business/${code.replaceAll('_', '-').toLowerCase()}.svg`),
                    height: this.imgHeight
                }
            default:
                return null
            }
        },
        sortedSectionsByNetwork(network) {
            return (network.subsections || []).reduce((acc, { news, code, orderNo }) => {
                const mappedNews = news.map(news => {
                    return {
                        ...news,
                        text: news.title + ` ${orderNo}`,
                        route: {
                            name: 'my-business-terms',
                            params: {
                                alias: network.code.toLowerCase(),
                                newsId: news.id
                            }
                        },
                        counter: !news.read ? '!' : null,
                        counterTooltip: 'Nieprzeczytany materiał',
                        image: this.setTermsImg(code),
                        orderNo: orderNo || null
                    }
                })
                return acc.concat(mappedNews)
            }, []).sort((a, b) => {
                // Sort alphabetically by title if orderNo values are equal
                if (a.orderNo === b.orderNo) {
                    return a.title.localeCompare(b.title)
                }
                // Sort by orderNo, null values pushed to the end
                return (a.orderNo === null) - (b.orderNo === null) || a.orderNo - b.orderNo
            })
        }
    }
}